import { render, staticRenderFns } from "./ClosePreviewComponent.vue?vue&type=template&id=32977e6e"
import script from "./ClosePreviewComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClosePreviewComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ClosePreviewComponent.vue?vue&type=style&index=0&id=32977e6e&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32977e6e')) {
      api.createRecord('32977e6e', component.options)
    } else {
      api.reload('32977e6e', component.options)
    }
    module.hot.accept("./ClosePreviewComponent.vue?vue&type=template&id=32977e6e", function () {
      api.rerender('32977e6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileManager/Preview/components/ClosePreviewComponent.vue"
export default component.exports